import logo from "../assets/loginteg.svg";

export default function Home() {
  return (
    <div className="w-full calculated-height flex justify-center items-center">
      <img width={250} src={logo} alt="company logo" />
    </div>
  );
}
